import React, { useState, useEffect } from 'react';
import { projectAPI } from '../../services/api';
import { useToast } from '../common/ToastContext';

export default function StatusSection({ projectId }) {
  const [status, setStatus] = useState('');
  const [fileCount, setFileCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const fetchStatus = async () => {
    try {
      const res = await projectAPI.getStatus(projectId);
      setStatus(res.data.status || res.status);
      setFileCount(res.data.fileCount || res.fileCount);
    } catch (err) {
      toast('Failed to fetch status', 'error');
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const handleProcess = async () => {
    setLoading(true);
    try {
      await projectAPI.process(projectId);
      toast('Indexing started', 'info');
      fetchStatus();
    } catch (err) {
      toast('Failed to start indexing', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded space-y-2">
      <div>Status: <strong>{status}</strong></div>
      {fileCount != null && (
        <div>Files Indexed: <strong>{fileCount}</strong></div>
      )}
      {status !== 'ready' && (
        <button
          onClick={handleProcess}
          className="btn-primary"
          disabled={loading}
        >
          {loading ? 'Starting...' : 'Start Indexing'}
        </button>
      )}
    </div>
  );
}
